import { GET_AXON_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function postHprAadhaarResendOtp({
  txn_id,
}: {
  txn_id: string;
}): Promise<AxonGenericApiResponse<{ txn_id: string; mobile_num: null }>> {
  try {
    const AXON_HOST = GET_AXON_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ txn_id });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${AXON_HOST}/hpr/aadhaar/resend-otp`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
